import React, { Component } from 'react';
import {Link,Redirect} from 'react-router-dom';
import {Form,Select,Input,Radio,InputNumber ,Button ,Breadcrumb,Spin,message,Checkbox} from 'antd';
import UploadFile from '../form/uploadFile';
import UploadFiles from '../form/uploadFiles';
import DatePicker from '../form/datePicker';
import Transfer from '../form/transfer';
import Combobox from '../form/combobox';
import moment from 'moment';
import servers from '@/api/server';
import history from '@/containers/history';
import {signUser} from '@/api/api';
import util from '@/api/util';
import styles from './login.module.css';
import md5 from 'md5';

const FormItem  = Form.Item;
const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const { TextArea } = Input;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 },
};
const formTailLayout = {
    wrapperCol: { span: 12, offset: 6 },
};

class SignUser extends Component{
    constructor(props){
        super(props);
        if(props.location.state){
            this.id = props.location.state.id;
        };
        let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
        this.state = {
            submit_loading:false,
            desUrlList:[],
            opUrlList:[],
            picUrlList:[],
            memberMockData:[],
            memberTargetKeys_0:[],
            memberTargetKeys_1:[],
            eqtNames:[],
            brandId:'',
            infoData:{},
            eqtList:[],
            buyTimeString:'',
            logoPath:httpStr + window.location.host + '/labpro/resources/skin/9/web/logo.png',
            checkedList: [],
            modeList:[],
            indeterminate: true,
            checkedIds:[],
            checkAll: false,
        };
        this.setValue = this.setValue.bind(this);
        this.loginSignUser = this.loginSignUser.bind(this);
        // this.signSubmit = this.signSubmit.bind(this)
        this.userSubmit = this.userSubmit.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.autoCpSearch = this.autoCpSearch.bind(this)
    }

    componentDidMount(){
        const that= this;    
    }   

    setValue=(feild,value)=>{
        this.setState({
            [feild]:value
        })
    }

   //邮箱后缀自动输入提示
   autoCpSearch = (value) => {
    let autoCpResult;
    if (!value || value.indexOf('@') >= 0) {
      autoCpResult = [];
    } else {
      autoCpResult = ['gmail.com', '163.com', 'qq.com','yahoo.com','hotmail.com','sina.com','sohu.com'].map(domain => `${value}@${domain}`);
    }
    this.setState({ autoCpResult });
  }

// 提交验证
handleSubmit=(e)=>{
    const that=this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
        if(err) {
            console.log(err)
            message.warning('请输入必填项！')
            return
        };
        that.setState({
            sureLoading:true
        });
        let params={
            source:1
        };
        for(let i in values){
            if(typeof values[i] !== 'undefined' ){
                params[i] = values[i];
                //格式化年份，并将其转为数值
                if(i === 'inYear'){
                    params[i] = parseInt(values['inYear'].format('YYYY'))
                };
                //md5登陆密码
                if(i === 'loginPws'){
                    params[i]=md5(values.loginPws)
                }
            };
        };
        console.log(params);
        this.userSubmit(params)
        
    });
}

// 注册请求
userSubmit(params){
    const that = this;
    const {signType} = this.state;
    that.setValue('submit_loading',true)
    console.log(signType);
    this.loginSignUser(params)
    
}

// 登陆注册
loginSignUser(params = {}){
    const that = this;
    signUser(params,res=>{
        console.log(res);
        that.setValue('submit_loading',false)
        if(res.statusCode === 1000){
            var con = "您已申请成功。如需加急，请联系实验室管理员，谢谢！";
            message.success(con);
            that.props.history.push( '/login',null)
            
        }else{
            message.warning(res.message)
        }
    },err=>{
        that.setValue('submit_loading',false)
        console.log(err)
        message.error('提交失败')
    })
}

    render(){
        const {submit_loading,logoPath,infoData} = this.state;
        const {getFieldDecorator,getFieldValue} = this.props.form;
        return(
            <div className={styles.login} id="login">
                <h1>
                    <img src={logoPath} alt="logo"/>
                </h1>
                <p className={styles.surport}>Copyright © 2018-2019 湖南巨擘科技有限公司 版权所有<br/>客服QQ:2471427571&nbsp;&nbsp;&nbsp;客服电话：18670037735&nbsp;&nbsp;&nbsp;7*24小时为您服务</p>
                
                <Form className={styles.login_form} onSubmit={this.handleSubmit}>
                <div>

                    <FormItem {...formTailLayout} >
                        
                    </FormItem>
                    <FormItem {...formItemLayout} label="邀请码">
                    {getFieldDecorator('signCode',{
                        rules: [
                            {required: true,message: '请输入邀请码'},
                        ],
                        initialValue:infoData.signCode ? infoData.signCode : '',
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="请输入实验室注册邀请码"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'240px'}}
                        />
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label="姓名">
                    {getFieldDecorator('name',{
                        rules: [
                            {required: true,message: '请输入姓名'},
                        ],
                        initialValue:infoData.nickName ? infoData.nickName : '',
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="请输入姓名"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'240px'}}
                        />
                    )}
                </FormItem>
                <FormItem label="身份证号码" {...formItemLayout}>
                    {getFieldDecorator('idCord',{
                        rules: [
                            {required: true,message: '请输入身份证号码'},
                            {patern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '请输入正确的身份证号码!'}
                        ],
                        validateTrigger:'onBlur',
                        initialValue:infoData.idCord ? infoData.idCord : '',
                    })(
                        <Input 
                            placeholder="请输入身份证号码"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'320px'}}
                        />
                    )}
                </FormItem>
                <FormItem label="手机号码" {...formItemLayout}>
                    {getFieldDecorator('phone',{
                        rules: [
                            {required: true,message: '请输入手机号码'},
                            {max:11,patern:/^1[34578]\d{9}$/,message: '请输入正确的手机号码!'}
                        ],
                        validateTrigger:'onBlur',
                        initialValue:infoData.mobile ? infoData.mobile : ''
                    })(
                        <Input 
                            placeholder="请输入手机号码"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'240px'}}
                        />
                    )}
                </FormItem>
                <FormItem label="登录名" {...formItemLayout}>
                    {getFieldDecorator('userName',{
                        rules: [
                            {required: true,message: '请输入账号名'},
                        ],
                        initialValue:infoData.userName ? infoData.userName : '',
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="请输入账号名"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'240px'}}
                        />
                    )}
                </FormItem>
                <FormItem label="登录密码" {...formItemLayout}>
                    {
                    getFieldDecorator('loginPws',{
                        rules: [
                            {patern: /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/,message: '5-16字符，仅限于字母数字下划线'}
                        ],
                        validateTrigger:'onBlur',
                    })(
                        <Input 
                            placeholder="不填写则默认密码为：123456"
                            size='large'
                            autoComplete="off" disableautocomplete='true'
                            style={{maxWidth:'250px'}}
                        />
                    )
                }
                </FormItem>
                </div>
                <div>
                    <FormItem {...formTailLayout}>
                        <div className={styles.login_btns}>
                            <Button htmlType="submit" type="primary" className={styles.signLab_btn} size="large"loading={submit_loading}>实验室用户注册</Button>  
                            <span className={styles.login_sign}> &nbsp;&nbsp;&nbsp;&nbsp;有账号？<a href="/login" >去登录</a></span>
                        </div>
                    </FormItem>
                    </div>
                </Form>
            </div>
        )
    }
}

export default Form.create({})(SignUser);